import React, { ChangeEvent } from "react";
import { useTranslation } from "react-i18next";
import Checkbox from "components/form/checkbox/Checkbox";

interface IProps {
  label: string;
  id: string;
  value: boolean | null;
  onChange: (value: boolean | null) => void;
}

export default function YesNoSetting(props: IProps) {
  const { label, id, value, onChange } = props;
  const { t } = useTranslation();

  function handleChange(event: ChangeEvent<HTMLInputElement>) {
    const { checked, value: nextValue } = event.target;
    if (!checked) {
      onChange(null);
      return;
    }
    onChange(nextValue === "true");
  }

  return (
    <div className="edit-segments-yes-no">
      <label className="text-base font-medium text-black block mb-2">{label}</label>
      <div className="edit-segments-yes-no-options">
        <Checkbox
          id={id}
          size="medium"
          value="true"
          checked={value === true}
          onChange={handleChange}
          label={t("Yes")}
          selectionOutline
        />
        <Checkbox
          id={id}
          size="medium"
          value="false"
          checked={value === false}
          onChange={handleChange}
          label={t("No")}
          selectionOutline
        />
      </div>
    </div>
  );
}
